import React, {Component} from 'react';
import {SpinnerButton} from "../SpinnerButton";
import { withTranslation } from 'react-i18next';

class SaveButtonComponent extends Component {
    render() {
        const { t } = this.props;
        let text = this.props.text ? this.props.text: t('save_button');

        if (this.props.isSaving) {
            return <SpinnerButton/>
        } else {
            // `guideAnchor`: el resultado de `anchorAttr(...)` cuando una guía apunta a este botón.
            return <input type="submit" onClick={this.props.onClick} value={text} className={this.buttonClass()}
                    disabled={!this.props.hasChanges} {...this.props.guideAnchor}/>
        }
    }

    buttonClass() {
        if (this.props.hasChanges) {
            return "btn -alt"
        } else {
            return "btn -alt disabled"
        }
    }
}

export const SaveButton = withTranslation()(SaveButtonComponent);
